import { Select, SelectSize, InputText, InputSize, IconClose } from '@ui/src';
import { useAppSelector } from '@store';
import InfoRow from '../../common/info-row';
import { CorporateApplicationStepTwoValuesTypes } from '../types';
import useStepTwoValues from '../hooks/use-step-two-values';

import commonStyles from '../../common/styles.module.css';
import cn from '../styles.module.css';

const StepTwoValue = ({
  value,
  setValue,
  setValuesList,
  index,
  type,
  values,
  disabled,
  clearErrors,
  applicationScheme,
}: CorporateApplicationStepTwoValuesTypes) => {
  const { monthlyTurnoverCorporate: monthlyTurnover, baseCurrency } =
    useAppSelector((state) => state.customersDictionaries);

  const { nameValue, onChange, deleteValue } = useStepTwoValues({
    values,
    index,
    type,
    setValue,
    clearErrors,
    setValuesList,
    value,
  });

  return (
    <>
      <InfoRow
        title={`${
          type === 'suppliers'
            ? applicationScheme?.suppliersNameTitle || 'Supplier'
            : applicationScheme?.customersNameTitle || 'Customer'
        } ${index + 1}`}
        id={type}
        lessPadding
      >
        <div className={cn.sicCodeRow}>
          <InputText
            name={`${type}-name-${index}`}
            placeholder={`Enter ${
              type === 'suppliers'
                ? applicationScheme?.suppliersNameTitle || 'supplier'
                : applicationScheme?.customersNameTitle || 'customer'
            } name...`}
            value={nameValue}
            onChange={onChange}
            size={InputSize.SMALL}
            className="borderless"
            tabIndex={disabled ? -1 : 0}
            disabled={disabled}
          />
          {!disabled && (
            <button
              type="button"
              className={cn.deleteSicCodeButton}
              onClick={() => deleteValue(value.id)}
              aria-label="Delete button"
              tabIndex={-1}
            >
              <IconClose width={15} height={15} />
            </button>
          )}
        </div>
      </InfoRow>
      <InfoRow
        title={`Expected ${
          type === 'suppliers'
            ? applicationScheme?.suppliersNameTitle || 'Supplier'
            : applicationScheme?.customersNameTitle || 'Customer'
        } ${index + 1} turnover (${baseCurrency?.name})`}
        borderless
        lessPadding
      >
        <Select
          name={`${type}-monthlyTurnoverRangeId-${index}`}
          placeholder="Select range"
          value={value.monthlyTurnoverRangeId}
          onChange={onChange}
          list={monthlyTurnover}
          size={SelectSize.SMALL}
          disabled={disabled}
          selectWrapperClassName={`${disabled ? commonStyles.selectDisabled : ''} ${cn.stepTwoSelectWrapper}`}
          tabIndex={disabled ? -1 : 0}
          borderless
        />
      </InfoRow>
    </>
  );
};

export default StepTwoValue;
